import qs from "qs";
import { toast } from "react-hot-toast";
import mainAxios from "../api/mainAxios";

export const getPromoteurs =
  (
    page = 1,
    pageSize = 25,
    searchItem = "",
    sortField = "name",
    sortDirection = "asc",
    widthLoading = true
  ) =>
  async (dispatch) => {
    try {
      widthLoading && dispatch({ type: "GET_PROMOTEURS_LOADING" });

      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const query = qs.stringify({
        populate: {
          logo: { fields: ["url"] },
          programmes_inclu: {
            populate: "lots",
          },
          promoteur_accesses: {
            fields: ["url_promoteur", "login", "password"],
            populate: "secteur",
          },
        },
        filters: {
          name: {
            $containsi: searchItem,
          },
        },
        sort: [`${sortField}:${sortDirection}`],
        pagination: {
          page,
          pageSize,
        },
      });

      const response = await mainAxios.get(`api/promoteurs?${query}`, config);

      dispatch({ type: "GET_PROMOTEURS_SUCCESS", payload: response.data });
    } catch (error) {
      console.error("error", error);
      dispatch({ type: "GET_PROMOTEURS_FAILURE", payload: error.message });
    }
  };

export const uploadPromoteurLogo = (promoteurId, file) => async (dispatch) => {
  try {
    // First, upload the file
    const formData = new FormData();
    formData.append("files", file);

    const uploadResponse = await mainAxios.post(`api/upload`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    });

    if (uploadResponse.data && uploadResponse.data[0]) {
      // Then, update the promoteur with the uploaded file ID
      await mainAxios.put(
        `api/promoteurs/${promoteurId}`,
        {
          data: {
            logo: uploadResponse.data[0].id,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Logo mis à jour avec succès");
    }
  } catch (error) {
    console.error(
      "Error uploading logo:",
      error.response?.data || error.message || error
    );
    toast.error("Erreur lors de la mise à jour du logo");
  }
};

export const handleSyncPromoteur = (promoteurId) => async (dispatch) => {
  try {
    const response = await mainAxios.get(
      `${process.env.REACT_APP_ENDPOINT_URL}api/update-gridky-single-promoteur/${promoteurId}`
    );

    if (response.status === 200) {
      toast.success("Synchronisation réussie");
      // Refresh the promoteurs list after successful update
    } else {
      toast.error("Echec de la synchronisation");
    }
  } catch (error) {
    console.error(error);
    toast.error("Erreur lors de la synchronisation");
  }
};

export const updateSinglePromoteur = (id, formData) => async (dispatch) => {
  try {
    const response = await mainAxios.put(
      `${process.env.REACT_APP_ENDPOINT_URL}api/promoteurs/${id}`,
      { data: formData }
    );

    if (response.status === 200) {
      toast.success("Promoteur mis à jour avec succès");
      // Refresh the promoteurs list after successful update
    } else {
      toast.error("Echec de la mise à jour du promoteur");
    }
  } catch (error) {
    console.error(error);
    toast.error("Erreur lors de la mise à jour du promoteur");
  }
};

export const addPromoteur = (formData) => async (dispatch) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    let logoId = null;
    if (formData.logo instanceof File) {
      const uploadFormData = new FormData();
      uploadFormData.append("files", formData.logo);

      const uploadResponse = await mainAxios.post(
        `api/upload`,
        uploadFormData,
        config
      );

      if (uploadResponse.data && uploadResponse.data[0]) {
        logoId = uploadResponse.data[0].id;
      }
    }

    const promoteurData = {
      ...formData,
      logo: logoId,
    };
    delete promoteurData.logoFile;

    const response = await mainAxios.post(
      `api/promoteurs`,
      { data: promoteurData },
      config
    );

    if (response.status === 201 || response.status === 200) {
      toast.success("Promoteur créé avec succès");
      return response.data.data;
    } else {
      toast.error("Echec de la création du promoteur");
      return null;
    }
  } catch (error) {
    console.error(error);
    toast.error("Erreur lors de la création du promoteur");
    return null;
  }
};

export const getSecteurs = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await mainAxios.get(`api/secteurs`, config);

    if (response.status === 200) {
      dispatch({ type: "GET_SECTEURS_SUCCESS", payload: response.data });
    } else {
      dispatch({ type: "GET_SECTEURS_FAILURE", payload: response.data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: "GET_SECTEURS_FAILURE", payload: error.message });
  }
};
